export default __webpack_public_path__ + "static/media/logout.030908e0.svg";